import React from 'react';
import { ArrowUp } from 'lucide-react';
import { colors } from '../../utils/constants';
import { RETURN_CATEGORIES, RETURN_LABELS } from '../../constants/chartConfig';

const GrowthMetrics = ({ metrics, title = 'Growth Percentage by Category' }) => {
  if (!metrics) return null;

  const renderMetricBox = (category, isTotal = false) => {
    const value = metrics[category];
    const label = RETURN_LABELS[category];

    const containerClasses = isTotal
      ? 'text-center p-4 rounded-lg border-2'
      : 'text-center p-4 bg-gray-50 rounded-lg';

    const containerStyle = isTotal
      ? { backgroundColor: 'rgba(51, 55, 144, 0.05)', borderColor: colors.lightBlue }
      : {};

    const labelClasses = isTotal
      ? 'text-sm font-medium mb-1'
      : 'text-sm text-gray-600 mb-1';

    const labelStyle = isTotal ? { color: colors.blue } : {};

    const valueClasses = isTotal
      ? 'text-xl font-bold'
      : 'text-xl font-bold text-gray-900';

    const valueStyle = isTotal ? { color: colors.blue } : {};

    return (
      <div key={category} className={containerClasses} style={containerStyle}>
        <div className={labelClasses} style={labelStyle}>{label}</div>
        <div className={valueClasses} style={valueStyle}>
          {value !== null ? `${value > 0 ? '+' : ''}${value}%` : 'N/A'}
        </div>
        <div className="flex items-center justify-center mt-1">
          {value > 0 ? (
            <span className={`text-xs flex items-center ${isTotal ? 'text-green-600 font-medium' : 'text-green-600'}`}>
              <ArrowUp className="w-3 h-3" /> Up
            </span>
          ) : value < 0 ? (
            <span className={`text-xs flex items-center ${isTotal ? 'text-red-600 font-medium' : 'text-red-600'}`}>
              Down
            </span>
          ) : (
            <span className="text-xs text-gray-500">Flat</span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="border-t pt-6">
      <h4 className="text-sm font-semibold text-gray-700 mb-4">{title}</h4>
      <div className="grid grid-cols-5 gap-3">
        {RETURN_CATEGORIES.map(category => renderMetricBox(category, false))}
        {renderMetricBox('total', true)}
      </div>
    </div>
  );
};

export default GrowthMetrics;
